import { createSelector } from "@reduxjs/toolkit";

export const selectSlice = state => state.account;

export const selectAccount = createSelector(selectSlice, state => state);
